import ReportsComponent from '../ReportsComponent.vue'

export default [
    {
        path: '/reports',
        name: 'Reports',
        meta: { layout: 'default' },
        component: ReportsComponent,
    },
]
